const _ = require('lodash');
const ModelCms = require('tscom-cms');

module.exports = ModelCms.extend({

    defaults: _.extend({}, ModelCms.prototype.defaults, {
        multilanguage: false,
        language: 'en'
    }),

    initialize: function( attributes, options ) {
        ModelCms.prototype.initialize.call( this, attributes, options );

        if( this.get('multilanguage') ) {
            let lang = 'en';

            try {
                lang = _.getQueryParamByName('lang') || localStorage.getItem('language');

                if( !lang ) {
                    lang = navigator.language.split('-').shift();
                }
            } catch( err ) {
                // do nothing
            }

            if( ['en', 'es', 'fr'].indexOf( lang ) === -1 ) {
                lang = 'en';
            }

            this.set({
                'language': lang
            }, {
                silent: true
            });

            this.listenTo( this, 'change:language' , function() {
                const language = this.get('language');

                try {
                    localStorage.setItem('language', language);
                } catch( err ) {
                    // do nothing
                }
                
                this.attributes = this.updateLanguage( this.attributes );
            });
        }
    },

    updateLanguage: function( data ) {
        if( this.get('multilanguage') ) {
            const views = Object.keys( data.text );
            const lang = this.get('language');
    
            views.forEach( function( key ) {
                const view = data.text[key];
    
                findCurrentLanguageCopy( view, lang );
    
            });
        }

        return data;
    },

    parse: function(raw, options) {
        const data = ModelCms.prototype.parse.call( this, raw, options);

        if( data === undefined ) {
            return undefined;
        }

        return this.updateLanguage( data );
    }
});

function findCurrentLanguageCopy( config, language ) {
    const keys = Object.keys( config );

    keys.forEach( function(key) {
        const suffix = key.substring( key.length - 3 );
        const hasSuffix = ['_en', '_es', '_fr'].indexOf( suffix ) > -1;

        if( suffix === '_en' ) {
            const genericKey = key.substring( 0, key.length - 3 );
            config[genericKey] = _.clone( config[genericKey + '_' + language], true );
        } else if( typeof config[key] === 'object' && !hasSuffix ) {
            findCurrentLanguageCopy( config[key], language );
        }

    } );
}


// WEBPACK FOOTER //
// ./app/scripts/models/cms.js